import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LogoBig from "../../components/Logo/LogoBig";
import { StyledBasedOn } from "../../styles/BasedOn";
import { StyledDescription, StyledHeader, StyledLogin, StyledForm } from "../../styles/StyledLoginPage";
import { Button } from "../../components/Button";
import { Error } from "../../components/Error";
import { getInvitation, acceptInvitation } from "../../api/user/invitation";

const INVALID_LINK = "This invitation link is invalid, has already been used or has expired. Ask your administrator to send a new invitation.";

/**
 * Opened from the link in an invitation email
 */
export default function AcceptInvitationPage() {
	const { token } = useParams();
	const [invitation, setInvitation] = useState(null);
	const [state, setState] = useState("loading"); // loading | form | invalid | done
	const [password, setPassword] = useState("");
	const [confirmation, setConfirmation] = useState("");
	const [errors, setErrors] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		getInvitation(token).then((res) => {
			if (res.ok) {
				setInvitation(res.data);
				setState("form");
			} else {
				setState("invalid");
			}
		});
	}, [token]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (password !== confirmation) {
			setErrors(["The passwords do not match."]);
			return;
		}
		setIsSubmitting(true);
		const res = await acceptInvitation(token, password);
		setIsSubmitting(false);
		if (res.ok) {
			setState("done");
		} else if (res.status === 404) {
			setState("invalid");
		} else {
			const fieldErrors = res.data?.fieldErrors?.map((error) => error.message) ?? [];
			setErrors(fieldErrors.length ? fieldErrors : ["Something went wrong. Please try again."]);
		}
	};

	return (
		<StyledLogin>
			<div className="inner">
				<StyledHeader>
					<LogoBig></LogoBig>
					<StyledBasedOn>BasedOn</StyledBasedOn>
					{state === "form" && (
						<StyledDescription>
							Welcome, {invitation.firstName}! Set a password for your account in {invitation.organizationName}.
						</StyledDescription>
					)}
				</StyledHeader>

				{state === "loading" && <p>Checking your invitation…</p>}

				{state === "invalid" && <Error>{INVALID_LINK}</Error>}

				{state === "done" && (
					<StyledForm as="div">
						<p>Your account is ready. Log in with your email address and your new password.</p>
						<Link to="/login">Go to log in</Link>
					</StyledForm>
				)}

				{state === "form" && (
					<StyledForm as="form" onSubmit={handleSubmit}>
						<label htmlFor="email">Email</label>
						<input type="email" id="email" name="email" value={invitation.email} readOnly autoComplete="username" />
						<label htmlFor="password">Password</label>
						<input
							type="password"
							id="password"
							name="password"
							autoComplete="new-password"
							onChange={(e) => setPassword(e.target.value)}
						/>
						<label htmlFor="confirmation">Confirm password</label>
						<input
							type="password"
							id="confirmation"
							name="confirmation"
							autoComplete="new-password"
							onChange={(e) => setConfirmation(e.target.value)}
						/>
						<p>At least 8 characters, with an uppercase letter, a lowercase letter and a number.</p>
						{errors.map((error) => (
							<Error key={error}>{error}</Error>
						))}
						<Button type="submit" disabled={isSubmitting || !password || !confirmation}>
							Set password
						</Button>
					</StyledForm>
				)}
			</div>
		</StyledLogin>
	);
}
